export default function DataList(){
  return (
    <>
    <div className="px-4">
      <h3>Data List</h3>
      <table className="table mt-3">
        <thead>
          <tr>
            <th>#</th>
            <th>Name</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>1</td>
            <td>Example</td>
            <td>Active</td>
          </tr>
        </tbody>
      </table>
      </div>
    </>
  );
}